<template>
  <aside class="welcome">
    <div>
      <div class="welcome__panel">
        <div class="welcome__panel-content">
          <Image :source="$beet.options.hunt.logos[$i18n.locale]" class="welcome__logo" />
          <h1 class="welcome__title">{{ $beet.options.hunt.desktop.title }}</h1>
          <p>{{ $beet.options.hunt.desktop.description }}</p>
        </div>
        <Image :source="$beet.options.hunt.desktop.mockup" class="welcome__mockup" />
      </div>
      <LangSwitch class="welcome__langSwitch" />
      <Tagline :text="$beet.options.hunt.desktop.tagline" class="welcome__tagline" />
    </div>
  </aside>
</template>

<script>
import { Image } from '@/components/global'
import LangSwitch from '@/components/navigation/LangSwitch.vue'
import { Tagline } from '@/components/small'

export default {
  name: 'DesktopWelcome',
  components: { Image, LangSwitch, Tagline },
}
</script>
